// layout.ts
export const layoutTokens = {
  "layout": {
    "grid": {
      "columns": {
        "mobile": {
          "value": 4,
          "type": "number",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": 4,
            "type": "number"
          },
          "name": "LayoutGridColumnsMobile",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "columns",
            "subitem": "mobile"
          },
          "path": [
            "layout",
            "grid",
            "columns",
            "mobile"
          ]
        },
        "tablet": {
          "value": 8,
          "type": "number",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": 8,
            "type": "number"
          },
          "name": "LayoutGridColumnsTablet",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "columns",
            "subitem": "tablet"
          },
          "path": [
            "layout",
            "grid",
            "columns",
            "tablet"
          ]
        },
        "desktop": {
          "value": 12,
          "type": "number",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": 12,
            "type": "number"
          },
          "name": "LayoutGridColumnsDesktop",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "columns",
            "subitem": "desktop"
          },
          "path": [
            "layout",
            "grid",
            "columns",
            "desktop"
          ]
        }
      },
      "gutter": {
        "mobile": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "LayoutGridGutterMobile",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "gutter",
            "subitem": "mobile"
          },
          "path": [
            "layout",
            "grid",
            "gutter",
            "mobile"
          ]
        },
        "tablet": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "LayoutGridGutterTablet",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "gutter",
            "subitem": "tablet"
          },
          "path": [
            "layout",
            "grid",
            "gutter",
            "tablet"
          ]
        },
        "desktop": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "LayoutGridGutterDesktop",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "gutter",
            "subitem": "desktop"
          },
          "path": [
            "layout",
            "grid",
            "gutter",
            "desktop"
          ]
        }
      },
      "margin": {
        "mobile": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "LayoutGridMarginMobile",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "margin",
            "subitem": "mobile"
          },
          "path": [
            "layout",
            "grid",
            "margin",
            "mobile"
          ]
        },
        "tablet": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "LayoutGridMarginTablet",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "margin",
            "subitem": "tablet"
          },
          "path": [
            "layout",
            "grid",
            "margin",
            "tablet"
          ]
        },
        "desktop": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "LayoutGridMarginDesktop",
          "attributes": {
            "category": "layout",
            "type": "grid",
            "item": "margin",
            "subitem": "desktop"
          },
          "path": [
            "layout",
            "grid",
            "margin",
            "desktop"
          ]
        }
      }
    },
    "container": {
      "maxWidth": {
        "mobile": {
          "value": "100%",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "100%",
            "type": "dimension"
          },
          "name": "LayoutContainerMaxWidthMobile",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "maxWidth",
            "subitem": "mobile"
          },
          "path": [
            "layout",
            "container",
            "maxWidth",
            "mobile"
          ]
        },
        "tablet": {
          "value": "768px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "768px",
            "type": "dimension"
          },
          "name": "LayoutContainerMaxWidthTablet",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "maxWidth",
            "subitem": "tablet"
          },
          "path": [
            "layout",
            "container",
            "maxWidth",
            "tablet"
          ]
        },
        "desktop": {
          "value": "1200px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "1200px",
            "type": "dimension"
          },
          "name": "LayoutContainerMaxWidthDesktop",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "maxWidth",
            "subitem": "desktop"
          },
          "path": [
            "layout",
            "container",
            "maxWidth",
            "desktop"
          ]
        }
      },
      "padding": {
        "mobile": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "LayoutContainerPaddingMobile",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "padding",
            "subitem": "mobile"
          },
          "path": [
            "layout",
            "container",
            "padding",
            "mobile"
          ]
        },
        "tablet": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "LayoutContainerPaddingTablet",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "padding",
            "subitem": "tablet"
          },
          "path": [
            "layout",
            "container",
            "padding",
            "tablet"
          ]
        },
        "desktop": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/grid.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "LayoutContainerPaddingDesktop",
          "attributes": {
            "category": "layout",
            "type": "container",
            "item": "padding",
            "subitem": "desktop"
          },
          "path": [
            "layout",
            "container",
            "padding",
            "desktop"
          ]
        }
      }
    },
    "breakpoints": {
      "mobile": {
        "value": "0px",
        "type": "dimension",
        "filePath": "design-tokens/grid.json",
        "isSource": true,
        "original": {
          "value": "0px",
          "type": "dimension"
        },
        "name": "LayoutBreakpointsMobile",
        "attributes": {
          "category": "layout",
          "type": "breakpoints",
          "item": "mobile"
        },
        "path": [
          "layout",
          "breakpoints",
          "mobile"
        ]
      },
      "tablet": {
        "value": "768px",
        "type": "dimension",
        "filePath": "design-tokens/grid.json",
        "isSource": true,
        "original": {
          "value": "768px",
          "type": "dimension"
        },
        "name": "LayoutBreakpointsTablet",
        "attributes": {
          "category": "layout",
          "type": "breakpoints",
          "item": "tablet"
        },
        "path": [
          "layout",
          "breakpoints",
          "tablet"
        ]
      },
      "desktop": {
        "value": "1024px",
        "type": "dimension",
        "filePath": "design-tokens/grid.json",
        "isSource": true,
        "original": {
          "value": "1024px",
          "type": "dimension"
        },
        "name": "LayoutBreakpointsDesktop",
        "attributes": {
          "category": "layout",
          "type": "breakpoints",
          "item": "desktop"
        },
        "path": [
          "layout",
          "breakpoints",
          "desktop"
        ]
      },
      "wide": {
        "value": "1440px",
        "type": "dimension",
        "filePath": "design-tokens/grid.json",
        "isSource": true,
        "original": {
          "value": "1440px",
          "type": "dimension"
        },
        "name": "LayoutBreakpointsWide",
        "attributes": {
          "category": "layout",
          "type": "breakpoints",
          "item": "wide"
        },
        "path": [
          "layout",
          "breakpoints",
          "wide"
        ]
      }
    }
  }
} as const;

export type LayoutTokens = typeof layoutTokens;
